module.exports = __webpack_public_path__ + "static/img/YIMEIONE.eec1f80b.png";